"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tabs_1 = require("./Tabs");
exports.Tabs = Tabs_1.default;
var TabList_1 = require("./TabList");
exports.TabList = TabList_1.default;
var TabPanel_1 = require("./TabPanel");
exports.TabPanel = TabPanel_1.default;
var TabPanels_1 = require("./TabPanels");
exports.TabPanels = TabPanels_1.default;
var Tab_1 = require("./Tab");
exports.Tab = Tab_1.default;
//# sourceMappingURL=index.js.map